import IndexesCrud from "./IndexesCrud";
export default {
  namespaced: true,
  state: () => {
    return {
      tableData: [],
      loading: false,
      working: false,
      slug: null,
      indexCrud: null,
    };
  },
  getters: {
    tableData(state) {
      return state.tableData;
    },
    formSchema(state, getters) {
      let x = state.tableData.length > 0 ? state.indexCrud.getFormSchema() : {}
      if(x.hasOwnProperty('iso_code'))
        x.iso_code = {key : 'iso_code'}
      console.log("formSchema" , x )
      return x;
    },
    loading(state) {
      return state.loading;
    },
    fields(state) {
      return state.tableData.length > 0 ? state.indexCrud.getFields() : [];
    },
    slug(state) {
      return state.slug;
    },
    indexCrud(state) {
      return state.indexCrud;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setData(state, payload) {
      state.tableData = payload;
    },
    setSlug(state, payload) {
      state.slug = payload;
    },
    setIndexesCrud(state, payload) {
      state.indexCrud = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async initState({ commit }, payload) {
      commit("setLoading", true);
      var crudObj = new IndexesCrud(payload.slug, payload.vue);
      commit("setIndexesCrud", crudObj);
      var data = await crudObj.all();
      if (data.data.data) commit("setData", data.data.data.records);
      else commit("setData", []);
      commit("setLoading", false);
    },

    async refreshData({ commit, state }) {
      commit("setLoading", true);
      var data = await state.indexCrud.all();
      if (data.data.data) commit("setData", data.data.data.records);
      else commit("setData", []);
      commit("setLoading", false);
    },

    async update({ commit, state, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await state.indexCrud.update(payload);
        await dispatch("refreshData");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async store({ commit, state, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await state.indexCrud.store(payload);
        await dispatch("refreshData");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async delete({ commit, state, dispatch }, id) {
      commit("setLoading", true);
      try {
        await state.indexCrud.delete(id);
        await dispatch("refreshData");
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
